<template>
  <div class="sn-container">
    <div class="wrap-container">
      <div class="table">
        <div  @click="handleButton($event)">
          <vue-seamless-scroll :data='listData' class="seamless-warp" :class-option="optionSetting">
            <table border='0' cellpadding='0' cellspacing='0' class='item'>
              <tbody>
              <tr v-for='(item, i) in listData' :key='i' class='labelIndex' :id='i'>
                <td width='100%' class="title">
                  <a href="#"><span>{{item.title}}</span></a>
                </td>
                <td width='16%'>
                  <span style="text-align: right">{{item.date}}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <div class="sn-more">
      <div class="more">
        <button class="more-button">
          查看更多 <i class="el-icon-d-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'Varticle',
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      // 数据
      newsRecommend:[],
      listData: [{
        title: '钱花哪了?一图带你读懂年轻人的消费观',
        date: '2020-05-05',
      }, {
        title: '“五一”假期前三天国内旅游收入超350亿元',
        date: '2020-05-02',
      }, {
        title: '滴滴、美团、哈啰交战，本地生活会是终局？',
        date: '2020-05-02',
      }, {
        title: '“互联网+文化”逆势上行文娱消费云端真精彩',
        date: '2020-04-25',
      }, {
        title: '乐观还是悲观？巴菲特是个现实主义者！',
        date: '2020-04-21',
      }, {
        title: 'B站的后浪，会把爱优腾拍在沙滩上吗?',
        date: '2020-04-20',
      }, {
        title: '华为如何做投资的：先给两亿订单一年上市',
        date: '2020-04-01',
      }, {
        title: '马斯克：特斯拉股价太高了，我要卖豪宅',
        date: '2020-03-25',
      }, {
        title: '人民日报海外版：云模式巧解“就业难”',
        date: '2020-03-16',
      }, {
        title: '刚刚港股"崩了"：狂跌近1000点！',
        date: '2020-03-12',
      }, {
        title: '个人健康信息码国家标准发布',
        date: '2020-02-28',
      }, {
        title: '传软银国际裁员约10%两名管理合伙人离职',
        date: '2020-02-15',
      }, {
        title: '27万个岗位：区块链、人工智能等专场招聘',
        date: '2020-02-10',
      }, {
        title: '一季度电商发展势头迅猛农村电商破1300万家',
        date: '2020-02-08',
      }]
    }
  },
  mounted() {
    // this.getRecommend()
  },
  computed:{
    optionSetting(){
      return{
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods:{
    // 处理鼠标点击到哪条，可添加跳转
    handleButton(e) {
      let InfoAnync = JSON.parse(e.target.dataset.obj)
      console.log(InfoAnync,' =====> InfoAnync')
      console.log(e, ' =====> e')
      console.log(e.path, ' =====> e.path')
      let length = e.path.length
      let labelIndex = -1
      for(let i=0;i < length; i++){
        if(e.path[i].className === 'labelIndex'){
          labelIndex = i;
          break
        }
      }
      if(labelIndex !== -1){
        console.log(e.path[labelIndex].innerText, ' =====> e.path[labelIndex].innerText')
        alert('labelIndex.id = ' + e.path[labelIndex].id + ',title： ' + this.listData[e.path[labelIndex].id].title)
      }else{
        alert('未找到数据，请检查')
      }

    },
    getRecommend(){
      let that = this
      this.$axios.get("http://127.0.0.1:5000/indexRecommend")
        .then(function (result) {
          that.newsRecommend = result.data;
          console.log(that.RecommendList)
        }).catch(function (error) {
        console.log(error);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
a{text-decoration: none;color:#b2b6bf;cursor: pointer;}
a:hover, a:visited, a:link, a:active { color:#b2b6bf;}
.sn-more{
  width: 98%;
  height: 8%;
  padding-top: 3%;
  overflow: hidden;
  .more{
    float: right;
    right: 20px;
    top: 10px;
    .more-button{
      background: #ffffff;
      border-radius: 15px;
      border: 1px solid #1688fe;
      line-height: 30px;
      width: 90px;
      font-size: 12px;
      font-weight: 500;
      color: #007dff;
      display: block;
      cursor: pointer;
    }
  }
}
.sn-container{
  width: 100%;
  height: 87%;
  %table-style{
    width: 100%;
    height: 35px;
    table-layout: fixed;
    tr {
      td {
        padding: 10px 5px;
        text-align: left;
        background-color: transparent;
        white-space: nowrap;
        overflow: hidden;
        color: #b2b6bf;
        font-size: 14px;
      }
    }
  }
  .table{
    .table-header{
      @extend %table-style;
    }
    .seamless-warp{
      height: 450px;
      overflow: hidden;
      visibility: visible;
      .item{
        height: auto;
        @extend %table-style;
        tr{
          td{
            &.title{
              text-overflow: ellipsis;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/article.vue